export default __webpack_public_path__ + "static/media/char.f20957a1.gif";